import { render, staticRenderFns } from "./textarea-normal.vue?vue&type=template&id=13fe2563&scoped=true"
import script from "./textarea-normal.vue?vue&type=script&lang=js"
export * from "./textarea-normal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe2563",
  null
  
)

export default component.exports